import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import BackgroundColor from "%/dynamic-components/render-engine/options/background-options/background-color";
import BackgroundImage from "%/dynamic-components/render-engine/options/background-options/background-image";
import BackgroundSize from "%/dynamic-components/render-engine/options/background-options/background-size";
import BackgroundRepeat from "%/dynamic-components/render-engine/options/background-options/background-repeat";
import BackgroundPosition from "%/dynamic-components/render-engine/options/background-options/background-position";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import BackgroundGradient from "%/dynamic-components/render-engine/options/background-options/background-gradient";

export default class BackgroundOptions extends BaseOptionsBundle {

  optionTitle = "Background";
  inspectorToolGroup = "background";
  useInspectorLabel = false;

  static optionClassName = "i-dynamic-background";
  static userInterfaceComponent = {
    component: inspectorTools.BACKGROUND_TOOL_SET,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new BackgroundColor(undefined, hideFromInspector["background-color"] ?? false),
      new BackgroundGradient(undefined, hideFromInspector["background-gradient"] ?? false),
      new BackgroundImage(undefined, hideFromInspector["background-image"] ?? false),
      BackgroundSize,
      BackgroundRepeat,
      BackgroundPosition,
    ]);
  }
}
